import React, { useState } from 'react';
import { Notification, Card } from "rbx";
import cep from 'cep-promise';
import ParkingService from '../../../services/parking';
import GeocodeService from '../../../services/geocoder';
import AppService from '../../../services/app';
import { placaMask, unMask } from '../../../commons/masks';
import Controls from '../../components/Controls/Controls';
import Autocomplete from '../../components/Autocomplete';

const styleHr = {
  backgroundColor: 'transparent', 
  borderColor: 'rgb(221, 221, 221)', 
  borderStyle: 'dashed', 
  borderWidth: '1px 0px 0px', 
  margin: '15px 0'
};

const AppRenewParkingForm = ({ setMessage, goToMenu }) => {
  const app = JSON.parse(sessionStorage.getItem('app'));
  const vehiclesParked = JSON.parse(sessionStorage.getItem('vehiclesParked'));

  const [licensePlate, setLicensePlate] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [street, setStreet] = useState('');
  const [streetNumber, setStreetNumber] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [status, setStatus] = useState('');
  const [stateButton, setStateButton] = useState('');

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStateButton("loading");
    try {
      let renewParking = {
        licensePlate: unMask(licensePlate),
        IMEI_UDID: process.env.REACT_APP_IMEI_DEFAULT,
        address: {
          state: state,
          city: city,
          neighborhood: neighborhood,
          street: street,
          street_number: streetNumber,
          zipcode: unMask(zipCode)
        },
        userType: "1",
        cpf_cnpj: app.cpf_cnpj
      }
      const response = await ParkingService.renew(renewParking);
      await AppService.findByCpf(app.cpf_cnpj);
      setMessage(['success', response.data.message]);
      goToMenu();
    } catch(e) {
      setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
    }
    setStateButton('');
  }

  const findAddressByCep = async (evt) => {
    evt.preventDefault();
    try {
      if (zipCode && zipCode.length===9) {
        const address = await cep(zipCode);
        setStreet(address.street.toUpperCase());
        setNeighborhood(address.neighborhood.toUpperCase());
        setCity(address.city.toUpperCase());
        setState(address.state.toUpperCase());
      } else {
        setStreet('');
        setNeighborhood('');
        setStreetNumber('');
        setCity('');
        setState('');
      }
    } catch(e) {
      console.log('Error: ', e);
    }
  }

  const findAddressByGoogle = async (evt) => {
    evt.preventDefault();
    try {
      const response = await GeocodeService.fromAddress(`${street}, FORTALEZA, CE`);
      const addressComponents = response.results[0].address_components;
      if (addressComponents.length > 6) {
        setStreetNumber(addressComponents[0].long_name);
        setStreet(addressComponents[1].short_name.toUpperCase());
        setNeighborhood(addressComponents[2].long_name.toUpperCase());
        setCity(addressComponents[3].long_name.toUpperCase());
        setState(addressComponents[4].short_name);
        setZipCode(addressComponents[6].long_name);
      } else if (addressComponents.length <= 4) {
        setStreetNumber('');
        setStreet(addressComponents[0].short_name.toUpperCase());
        setNeighborhood('');
        setCity(addressComponents[1].long_name.toUpperCase());
        setState(addressComponents[2].short_name);
        setZipCode('');
      } else {
        setStreetNumber('');
        setStreet(addressComponents[0].short_name.toUpperCase());
        setNeighborhood(addressComponents[1].long_name.toUpperCase());
        setCity(addressComponents[2].long_name.toUpperCase());
        setState(addressComponents[3].short_name);
        setZipCode(addressComponents[5] ? addressComponents[5].long_name : '');
      }
    } catch(error) {
      setStatus(['danger', `${error}`]);
      console.error(error);
    }
  }


  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>Renovar um estacionamento</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Autocomplete
            suggestions={vehiclesParked.map((licensePlate)=>placaMask(licensePlate))}
            label="Placa do veículo"
            name="licensePlate"
            placeholder="ABC-1234"
            value={licensePlate}
            setValue={value => setLicensePlate( placaMask(value) )}
            focus={true}
            required
          />
          <hr style={ styleHr }/>
          <Controls.ZipCodeField 
            label="CEP"
            name="zipCode"
            placeholder='_____-___'
            value={zipCode}
            onChange={e => setZipCode(e.target.value)}
            onClick={findAddressByCep}
            required
          />
          <Controls.TextFieldWithSearch 
            label="Logradouro"
            name="street"
            placeholder='Pesquise no Google Maps'
            value={street}
            onChange={e => setStreet(e.target.value.toUpperCase())}
            onClick={findAddressByGoogle}
            required
          />
          <Controls.TextField 
            label="Número"
            name="streetNumber"
            value={streetNumber}
            onChange={e => setStreetNumber(e.target.value.toUpperCase())}
            required
          />
          <Controls.TextField 
            label="Bairro"
            name="neighborhood"
            value={neighborhood}
            onChange={e => setNeighborhood(e.target.value.toUpperCase())}
            required
          />
          <Controls.TextField 
            label="Município"
            name="city"
            placeholder='FORTALEZA'
            value={city}
            onChange={e => setCity(e.target.value.toUpperCase())}
            required
          />
          <Controls.TextField 
            label="UF"
            name="state"
            placeholder='CE'
            value={state}
            onChange={e => setState(e.target.value.toUpperCase())}
            required
          />
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={goToMenu} 
            buttonState={stateButton} 
            buttonName='Renovar'
          />
        </Card.Content>
      </Card>
    </form>
  )

}

export default AppRenewParkingForm;
